export default __webpack_public_path__ + "static/media/puzzle.12a08b61.jpg";